import { DEVICE_LINKING } from '../../constants/device-linking';
import DeviceItem from './DeviceItem';

type Props = {
  deviceIds: string[];
  currentDeviceId: string;
  isUnlinking: string | null;
  onUnlink: (deviceId: string) => void;
};

export default function LinkedDevicesList({
  deviceIds,
  currentDeviceId,
  isUnlinking,
  onUnlink,
}: Props) {
  const isAtLimit = deviceIds.length >= DEVICE_LINKING.MAX_DEVICES;

  if (deviceIds.length === 0) {
    return null;
  }

  return (
    <div className="p-3 sm:p-4 bg-blue-50 border border-blue-200 rounded-lg">
      <h3 className="text-base sm:text-lg font-semibold mb-2 text-gray-900">
        Linked Devices
      </h3>
      <div className="text-base text-gray-600 mb-2 sm:mb-3">
        {deviceIds.length} device{deviceIds.length !== 1 ? 's' : ''} linked
        {isAtLimit && ' (Maximum reached)'}
      </div>
      <div className="space-y-2">
        {deviceIds.map((id, index) => (
          <DeviceItem
            key={id}
            deviceId={id}
            index={index}
            isCurrentDevice={id === currentDeviceId}
            isUnlinking={isUnlinking === id}
            onUnlink={() => onUnlink(id)}
          />
        ))}
      </div>
    </div>
  );
}
